import SuperRepository from '../superRepository'

export default new (class AdvertiserLandingOrderRepository extends SuperRepository {
  baseUri() {
    return 'default_landings_landing'
  }
})()